// Hand-written SEO title/description copy for specific real routes, keyed by
// the exact path used in <Seo path="...">. Falls back to the existing
// generic "{name} Perth" title / DB description when a route has no entry
// here — this only overrides the pages that have been given real copy.
export const SEO_OVERRIDES = {
  "/services/colorbond-fencing": {
    title: "Colorbond Fencing in Perth | Supply & Installation | Stag Fencing",
    description:
      "Durable Colorbond fencing installation in Perth. Available in full Colorbond palette with 10-yr warranty. Request your free measure & quote today!",
  },
  "/services/aluminium-slat-fencing-perth": {
    title: "Aluminium Slat Fencing Perth | Custom Slat Gates & Screens",
    description:
      "Modern aluminium slat fencing & privacy screens in Perth. Low maintenance, custom spacing & colors. Get an instant estimate or free quote today.",
  },
  "/services/pool-fencing": {
    title: "Pool Fencing Perth | Glass & Aluminium Safety Barriers | Stag Fencing",
    description:
      "WA safety compliant pool fencing in Perth. Choose frameless glass or tubular aluminium pool barriers built to last. Free quote & measure!",
  },
  "/services/retaining-walls": {
    title: "Retaining Walls Perth | Concrete Panel & Limestone Solutions",
    description:
      "Expert retaining wall installation under fences in Perth. Limestone & concrete panel walls engineered for WA soils. Call for a fixed quote!",
  },
  "/services/gates-automation": {
    title: "Custom Gates & Automation Perth | Sliding & Swing Gates | Stag Fencing",
    description:
      "Custom pedestrian & driveway gates with electric automation in Perth. High security, remote access & sleek design. Request a free quote!",
  },
  "/services/security-fencing": {
    title: "Commercial Security Fencing Perth | Garrison & Chain Mesh | Stag Fencing",
    description:
      "Heavy-duty commercial & industrial security fencing in Perth. Garrison fencing, security gates & chainlink enclosures. Protect your property!",
  },
  "/services/asbestos-fence-removal": {
    title: "Licensed Asbestos Fence Removal Perth | Safe Disposal | Stag Fencing",
    description:
      "WorkSafe WA licensed asbestos fencing removal & replacement in Perth. Safe removal, disposal & instant replacement with Colorbond fencing.",
  },
  "/services/pvc-fencing": {
    title: "PVC Fencing Perth | Low-Maintenance Fence Installation | Stag Fencing",
    description:
      "Upgrade your property with durable, low-maintenance PVC fencing in Perth. Stag Fencing provides professional PVC fence supply and installation.",
  },
  "/services/modular-walls": {
    title: "Modular Walls Perth | Modular Fencing Solutions | Stag Fencing",
    description:
      "Create a modern boundary with modular walls in Perth. Stag Fencing supplies and installs practical modular wall solutions for residential properties.",
  },
  "/services/blade-fencing": {
    title: "Blade Fencing in Perth | Secure Boundary Fencing | Stag Fencing",
    description:
      "Choose strong, modern blade fencing in Perth for improved property security and privacy. Stag Fencing provides professional supply and installation.",
  },
  "/services/security-fencing/chainmesh-fencing": {
    title: "Chainmesh Fencing in Perth | Security Fencing | Stag Fencing",
    description:
      "Chainmesh fencing in Perth for homes, businesses and commercial properties. Stag Fencing provides durable security fencing with professional installation. Get a free quote.",
  },
  "/services/security-fencing/garrison-fencing": {
    title: "Garrison Fencing Perth | High-Security Fencing | Stag Fencing",
    description:
      "Protect your property with durable Garrison fencing in Perth. Stag Fencing provides professional high-security fencing solutions for commercial and residential properties.",
  },
  "/services/security-fencing/enclosures": {
    title: "Security Enclosures Perth | Custom Fencing Solutions | Stag Fencing",
    description:
      "Stag Fencing builds secure enclosures in Perth for homes, businesses and equipment. Get a practical fencing solution designed around your property.",
  },
  "/services/security-fencing/palisade-fencing": {
    title: "Palisade Fencing in Perth | Security Fencing | Stag Fencing",
    description:
      "Palisade fencing in Perth for strong, reliable property security. Stag Fencing supplies and installs durable palisade fencing for homes and businesses.",
  },
  "/services/gates-automation/automation": {
    title: "Automatic Gates Perth | Gate Automation | Stag Fencing",
    description:
      "Upgrade your Perth property with automatic gate automation from Stag Fencing. Enjoy convenient, secure access with professional installation.",
  },
  "/services/gates-automation/sliding-gates": {
    title: "Sliding Gates Perth | Sliding Gate Installation | Stag Fencing",
    description:
      "Get durable sliding gates in Perth with professional installation from Stag Fencing. Choose practical, secure gate solutions for homes and businesses.",
  },
  "/services/gates-automation/swing-gates": {
    title: "Swing Gates Perth | Custom Gate Installation | Stag Fencing",
    description:
      "Get quality swing gates in Perth designed for security, access and style. Stag Fencing provides custom swing gate solutions and professional installation.",
  },
};
